const arrayParams = (object, prefix = '') => {
  let params = [];

  if (Array.isArray(object)) {
    object.forEach(val => {
      params = params.concat(arrayParams(val, `${prefix}[]`));
    });
  } else if ( object == null ) {
    return params;
  } else if (typeof object === 'object') {
    Object.entries(object)
      .forEach(([key, val]) => {
        const paramKey = prefix === ''
          ? encodeURIComponent(key)
          : `[${encodeURIComponent(key)}]`;
        params = params.concat(arrayParams(val, prefix + paramKey));
      });
  } else if (typeof object !== 'undefined') {
    params = params.concat(`${prefix}=${encodeURIComponent(object.toString())}`);
  }

  return params;
};

/**
 * Serializes a parameter object using rails nested path syntax.
 *
 * For example the following object:
 *
 *   {
 *     fizz: 'buzz'
 *     foo: {
 *       bar: [1, 2]
 *     },
 *   }
 *
 * ...will serialize to:
 *
 *   fizz=buzz&foo[bar][]=1&foo[bar][]=2
 *
 * @param param the parameters
 * @return parameter string
 */
export default (param) => arrayParams(param)
  .join('&');
